export default {
    GET_MY_SETTINGS_DATA: 'GET_MY_SETTINGS_DATA',
    MY_SETTINGS_DATA: 'MY_SETTINGS_DATA',
    MY_LANGUAGE: 'MY_LANGUAGE',
    MY_TIMEZONE: 'MY_TIMEZONE',
    MY_DATE_INPUT_STYLE: 'MY_DATE_INPUT_STYLE',
    MY_FIRST_DAY_OF_WEEK: 'MY_FIRST_DAY_OF_WEEK',
    MY_DATE_FORMAT: 'MY_DATE_FORMAT',
    MY_SECURITY_QUESTIONS: 'MY_SECURITY_QUESTIONS',
    MY_SSP_THEME: 'MY_SSP_THEME',
    MY_CUSTOM_LIST_VALUES: 'MY_CUSTOM_LIST_VALUES',
    GET_MY_LANGUAGE: 'GET_MY_LANGUAGE',
    GET_MY_TIMEZONE: 'GET_MY_TIMEZONE',
    GET_MY_DATE_INPUT_STYLE: 'GET_MY_DATE_INPUT_STYLE',
    GET_MY_FIRST_DAY_OF_WEEK: 'GET_MY_FIRST_DAY_OF_WEEK',
    GET_MY_DATE_FORMAT: 'GET_MY_DATE_FORMAT',
    GET_MY_SECURITY_QUESTIONS: 'GET_MY_SECURITY_QUESTIONS',
    GET_MY_SSP_THEME: 'GET_MY_SSP_THEME',
    GET_MY_CUSTOM_LIST_VALUES: 'GET_MY_CUSTOM_LIST_VALUES'
}


// WEBPACK FOOTER //
// ./constants/mySettings.js